/**
 * Created by intellicar-rinas on 23/9/17.
 */
import React, {Component} from 'react';
import './InMultiSelect.css';
import Dom from '../../../../helpers/Dom';
import $ from 'jquery';
import {connect} from 'react-redux';
import actions from '../../../../store/actions';
// import store from '../../../../store'
import ReactDOM from 'react-dom';
import _ from 'lodash';
// import {clearData} from '../InTable/InTable';

let MapPropsToState = (state) => {
    const {roadStats, ...restOfTheState} = state;
    return {store: restOfTheState};
};

// const InMultiSelect = React.forwardRef((props, ref) => {
//     return <InMultiSelectClass {...props} forwardedRef={ref} />;
//   });

class InMultiSelectClass extends Component{

    state = {
        focus:false,
        selectedItems: [],
        focusedItem: 0,
        search: '', // used only by second placeholder
        index:0,
        splitButton:false,
        tab: this.props.store.reportWindow.tab.key,
        selectAllClicked:false,
        selectedTripVehicles: null,
        selectedDailyVehicles: null,
        selectedSummaryVehicles: null,
        clearTripVehicles: false,
        clearDailyVehicles: false,
        clearSummaryVehicles: false,
    };

    constructor(props){
        super(props);
        // this.containerRef = props.forwardedRef || React.createRef();
        this.containerRef = React.createRef(); 
        this.inputRef = React.createRef();

        window.multiselectUpdate = () => {
            let canParam = []
            if(window.metrics && this.props.store.reportWindow.tab.key === "can_data_dump_report"){
                for(let idx in window.metrics){
                    let data = {
                        data :window.metrics[idx],
                        id:idx,
                        name:window.metrics[idx].metrics
                    }
                    canParam[idx] = data
                }
            }
            this.props.data.listData = canParam
            this.forceUpdate()
        }
        window.multiselectClear = () => {
            this.props.data.listData = []
            this.props.data.selectedItems = []
            this.setState({selectAllClicked: false})
        }

        if(!this.props.data){
            console.error("'data' attribute is undefined");
            return;
        }

        if(!this.props.data.selectedItems){
            this.props.data.selectedItems = [];
        }

        this.getPlaceholder = () => {
            if(this.props.data.key === "metrics" && this.props.store.reportWindow.tab.key === "can_data_dump_report" && window.metricsClicked){
                return "Fetching Metrics..."
            }
            if(this.props.data.key === "metrics" && this.props.store.reportWindow.tab.key === "jem_can_data_dump_report" && window.metricsClicked && window.matricsData){
                return "Fetching Metrics..."
            }
            if(this.props.data.key === "metrics" && this.props.store.reportWindow.tab.key === "bg_can_data_dump_report" && window.metricsClicked && window.matricsData){
                return "Fetching Metrics..."
            }
            if(this.isSingleSelect()) {
                    let selectedVehicle = this.props.data.selectedItems && this.props.data.selectedItems.length ? this.props.data.selectedItems : window.selectedItems && window.selectedItems.length ? window.selectedItems : window.selectedVehicles && window.selectedVehicles.length ? window.selectedVehicles : []
                    if(selectedVehicle.length){
                        if (this.props.data.key === "vehicle"){
                        //    this.refs.input.value = selectedVehicle[0].name
                            if (document.getElementById('selectBox')){
                              document.getElementById('selectBox').value = selectedVehicle[0].name
                            }
                        }else{
                        //  return selectedVehicle[0].name
                            return "Search"
                        }
                    }else{
                        return "Search";
                    }
            }
            else if(this.props.data.placeholder){
                return this.props.data.placeholder;
            }
            else if(this.state.selectAllClicked && window.selectedItems && window.selectedItems.length === this.props.data.listData.length  ){
                return window.selectedItems.length + " items selected of " + window.selectedItems.length
            }
            else{
                if(window.selectedItems && window.selectedItems.length >0  && this.state.splitButton &&  window.selectedItems.length<100){
                    return (window.selectedItems && window.selectedItems.length ? window.selectedItems.length : window.selectedVehicles && window.selectedVehicles.length ? window.selectedVehicles.length : 0) + " items selected of " + (this.props.data.listData || []).length;
                }
                else if(window.selectedItems && window.selectedItems.length >0  && this.state.splitButton){
                    return this.getStartIndex()+" to "+this.getLastIndex()+ " items selected of " + (this.props.data.listData || []).length;
                    }
                    else{
                        if(this.props.data.key === "vehicle"){
                            return (window.selectedItems && window.selectedItems.length ? window.selectedItems.length : window.selectedVehicles && window.selectedVehicles.length ? window.selectedVehicles.length : 0) + " items selected of " + (this.props.data.listData || []).length;
                        }
                        if(this.props.data.key !== "vehicle") {
                            return (this.props.data.selectedItems && this.props.data.selectedItems.length ? this.props.data.selectedItems.length : 0) + " items selected of " + (this.props.data.listData || []).length;
                        }
                    }
            }
        };
        
        this.setFocusActive=()=>{
            this.setState({focus:true});

        }
        this.onFocus = () => {
            if(this.unmounted) return;
            // this.filterList({focus: true, focusedItem: 0});
            this.openDwop();
        };

        this.hide = (e) => {
            if(this.unmounted) return;
            if(!e || !ReactDOM.findDOMNode(this) || !ReactDOM.findDOMNode(this).contains(e.target))
                this.setState({focus:false});
        };

        this.setInputValue = (str) => {
            this.inputRef.current.value = str;
        };

        this.setData = (data, force=false) => {
            if((!(this.rawData && this.rawData.data === data.data) || this.dataid !== data.dataid) &&
                (force || !this.props.data.listData || this.props.data.listData.length === 0)){

                    if(!this.state.focus){
                    // this.refs.input.value = "";
                }
                this.rawData = data;
                this.dataid = data.dataid ? data.dataid : null;
                let list = [];
                for(let idx in data.data){
                    list.push({
                        name:data.data[idx][data.name],
                        id:data.data[idx][data.id],
                        data:data.data[idx]
                    });
                }
                this.props.data.listData = list;
                this.filterList();
            }
        };

        if(this.props.data && this.props.data.connect){
            MapPropsToState = this.props.data.connect;
        }

        document.addEventListener('mousedown', (e)=>{
            let container = $(this.containerRef);
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                this.hide(e);
            }
        });

        window.onEscape('inmultiselect', () => {
            if(this.state.focus) {
                this.hide();
                return false;
            }
        });
        window.addEventListener('keydown', this.shortkeys);

        this.onInputChange = () => {
            if(this.unmounted) return;
            if (this.props.data.singleSelect){
                this.props.data.selectedItems = []
                window.selectedItems = []
                window.selectedVehicles = []
            }
            this.setState({focus:true, search: this.inputRef.current.value});
            if(this.props.data.onChange) {
                this.props.data.onChange(this.getSelectedItems());
            }
            this.filterList({focusedItem:0});
        };

        this.filterList = (state) => {
            if(this.unmounted) return;
            let tempList = [];
            let str = this.inputRef.current.value;
            // if(!str) str = "";
            if(!str || str.length < 3) {
                // Don't filter if search term is too short
                this.setState({
                    list: this.props.data.listData || [],
                    ...state 
                });
                return;
            }
            str = str.trim().toLowerCase();
            for(let idx in this.props.data.listData){
                if(this.props.data.listData[idx].name.toLowerCase().indexOf(str) !== -1){
                    tempList.push(this.props.data.listData[idx]);
                }
                if(tempList.length > 20){
                    break;
                }
            }
            this.checkIsValid(this.getSelectedItems());
            this.setState(Object.assign({list:tempList}, state));
        };

        this.checkIsValid =list=> {
            this.setState({valid: list && list[0] ? list[0].name === this.inputRef.current.value : false});
        };

        this.getListData = () => {
            return this.state.list || [];
        };

        this.isSelected = (item) => {
            let selectedItems = this.getSelectedItems()
            for(let idx in selectedItems){
                if(parseInt(item.id) === parseInt(selectedItems[idx].id)){
                    return {index: idx};
                }
                if(this.isSingleSelect()){
                    break;
                }
            }
            return false;
        };

        this.setItemById = (id) => {
            this.props.data.selectedItems = this.props.data.listData.filter(i=>{return i.id == id});
            if(this.getSelectedItems().length) {
                this.inputRef.current.value = this.getSelectedItems()[0].name;
            }
            this.forceUpdate();
            if(this.props.data.onClick) {
                this.props.data.onClick(this.getSelectedItems(), {dispatch:this.props.dispatch});
            }
            if(this.props.data.onItemChange) {
                this.props.data.onItemChange(this.getSelectedItems(), this.props);
            }
            this.checkIsValid(this.getSelectedItems());
            return this.getSelectedItems();
        };

        this.setItemByIds = (ids) => {
            if(this.props.data.key == "status"){
                this.props.data.selectedItems = this.props.data.listData.filter(i=>{
                    return i.data.state == true
                });
            }else{
            this.props.data.selectedItems = this.props.data.listData.filter(i=>{
                return ids.indexOf(i.id) !== -1;
            });
        }
            // if(this.props.data.key === "vehicle") window.selectedItems = this.props.data.selectedItems
            if(this.getSelectedItems().length) {
                // this.inputRef.current.value = this.getSelectedItems()[0].name;
            }
            this.forceUpdate();
            // if(this.props.data.onClick) {
            //     this.props.data.onClick(this.props.data.selectedItems, {dispatch:this.props.dispatch});
            // }
            // if(this.props.data.onChange) {
            //     this.props.data.onChange(this.props.data.selectedItems);
            // }
            this.checkIsValid(this.getSelectedItems());
            return this.getSelectedItems();
        };

        this.onItemClick = (item, index) => {
            window.itemClicked = true
            const isSelected = this.isSelected(item);
            if(this.getSelectedItems().length >= this.getMaxItemCount() && !isSelected) {
                this.throwMaxStackPopup();
            } else {
                let tempList = [];
                if(this.isSingleSelect()){
                    tempList.push(item);
                    this.inputRef.current.value = item.name;
                    this.setState({search: item.name, focus: false});
                }else{
                    tempList = [...this.getSelectedItems()];
                    if(isSelected){
                        tempList.splice(isSelected.index, 1);
                    }else{
                        tempList.push(item);
                    }
                    // this.inputRef.current.value = tempList.length ? tempList[0].name : '';
                    this.setState({search: tempList.length ? tempList[0].name : ''});
                }
                this.props.data.selectedItems = tempList;
                // let reportKey = this.props.store.reportWindow.tab.key
                if(this.props.data.key === "vehicle") window.selectedItems = tempList;
                if(this.props.data.onClick) {
                    this.props.data.onClick(this.getSelectedItems(), {dispatch:this.props.dispatch});
                }
                if(this.props.data.onChange) {
                    this.props.data.onChange(this.getSelectedItems());
                }
                if(this.props.data.onItemChange) {
                    this.props.data.onItemChange(this.getSelectedItems(), this.props);
                }
                this.checkIsValid(this.getSelectedItems());
                this.focusedItem = index;
                this.forceUpdate();
            }
        };

        this.isActive = (item, i) => {
            if(this.state.focusedItem === i) return true;
        };

        this.isSingleSelect = () => {
            return this.props.data && this.props.data.singleSelect;
        };

        this.getData = () => {
            return this.getSelectedItems() || [];
        };

        this.nextList = (i)=>{
            let len = Math.ceil(this.props.data.listData.length/this.getMaxItemCount())
            if(i <= len-1){
            this.props.data.selectedItems = [...this.props.data.listData]
            this.props.data.selectedItems = this.props.data.selectedItems
                .slice( i*this.getMaxItemCount(), this.props.data.selectedItems.length <= (i*this.getMaxItemCount())+this.getMaxItemCount()? this.props.data.selectedItems.length:(i*this.getMaxItemCount())+this.getMaxItemCount());
                this.setState({index:i})
            this.checkIsValid(this.getSelectedItems());
            if(this.props.data.listData[i*this.getMaxItemCount()]){
            document.getElementById(this.props.data.listData[i*this.getMaxItemCount()].name).scrollIntoView()
            }
            }
            window.selectedItems = this.props.data.selectedItems 
        }

        this.prevList = (index)=>{
            if(index >= 0){
            this.props.data.selectedItems = [...this.props.data.listData]
            this.props.data.selectedItems = this.props.data.selectedItems
                .slice( index*this.getMaxItemCount(), this.props.data.selectedItems.length <= (index*this.getMaxItemCount())+this.getMaxItemCount()? this.props.data.selectedItems.length:(index*this.getMaxItemCount())+this.getMaxItemCount());
                this.setState({index:index})
            this.checkIsValid(this.getSelectedItems());
            document.getElementById(this.props.data.listData[index*this.getMaxItemCount()].name).scrollIntoView()
            window.selectedItems = this.props.data.selectedItems    
            }
        }


        this.selectAll =()=> {
            let reportKeys = ["new_trip_report","trip_report","daily_report","summary_report","can_data_dump_report","jem_can_data_dump_report","bg_can_data_dump_report","can_daily_report","range_report","download_report","mileage_report"]
            const currentList = this.state.search ? this.getListData() : this.props.data.listData;
            if(reportKeys.includes(this.state.tab)){
                window.selectedItems = [...currentList] 
                // if(this.props.data.key === "vehicle") window.selectedVehicles = [...this.props.data.listData]
                this.props.data.selectedItems = window.selectedItems
                // if(this.props.data.key === "vehicle") window.selectedVehicles = window.selectedItems
                this.setState({selectAllClicked: true})
                if(this.state.search){
                    window.selectAllClicked = false
                }else{
                    window.selectAllClicked = true
                }              
                this.checkIsValid(this.props.data.selectedItems);  
            }else{
            this.props.data.selectedItems = [...currentList]
            this.props.data.selectedItems = this.props.data.selectedItems
                .slice( this.state.index, this.getMaxItemCount());
            window.selectedItems = this.props.data.selectedItems
            window.selectedVehicles = this.props.data.selectedItems
                    this.setState({splitButton: true, focus:true, index:0, search: ''})

                if(this.props.data.selectedItems.length ==10 && this.props.store.reportWindow.tab.name == "Ride Report"){
                    this.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                          name: "You can't select more than 10 vehicles",
                          content: "You can't select more than 10 vehicles",
                          createAt: Date.now(),
                          autoClose: 8000,
                          showError:true
                        },
                      });
                }
                if(this.props.data.selectedItems.length ==100){
                    this.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                        name: "You can't select more than 100 vehicles",
                        content: "You can't select more than 100 vehicles",
                        createAt: Date.now(),
                        autoClose: 8000,
                        showError:true
                        },
                    });
            }
            this.checkIsValid(this.getSelectedItems());

            }


            this.forceUpdate();
        };

        this.deSelectAll =()=> {
            this.inputRef.current.value = ''
            // document.getElementById("selectBox").value = ''
            this.props.data.selectedItems = [];
            // window.selectedVehicles = []
            this.checkIsValid(this.getSelectedItems());
            this.forceUpdate();
            window.selectAllClicked = false
            this.setState({splitButton:false, search: '', index:0,selectAllClicked: false},() =>{
            })
            if(this.props.data.key === "vehicle"){
                this.inputRef.current.value = ''
                document.getElementById("selectBox").value = ''
                this.props.data.selectedItems = [];
                window.selectedVehicles = []
                this.setState({selectAllClicked : false})
                window.selectedItems = []
                this.checkIsValid(this.getSelectedItems());
                this.forceUpdate();

            }
            let key = this.props.store.reportWindow.tab.key
            let reportKeys = ["trip_report","daily_report","summary_report"]
            // if(reportKeys.includes(key) && this.props.data.key === "vehicle"){
            //     window.selectedItems = []
            //     // if(key === "trip_report"){
            //     //     this.setState({selectedTripVehicles: [], clearTripVehicles: true},() => {})
            //     // }
            //     // else if(key === "daily_report"){
            //     //     this.setState({selectedDailyVehicles: [], clearDailyVehicles: true})
            //     // }
            //     // else if(key === "summary_report"){
            //     //     this.setState({selectedSummaryVehicles: [], clearSummaryVehicles: true})
            //     // }
            //     this.forceUpdate();
            // }
        };
    }

    shortkeys =(e)=>{
        // if(e.keyCode === 13 && !e.ctrlKey) {
        //     if(_.get(this.state, 'list.length')) {
        //         this.onItemClick(this.state.list[this.state.focusedItem], this.state.focusedItem);
        //     }
        // }
        if(e.target === this.inputRef && (e.keyCode === 38 || e.keyCode === 40)) {
            e.preventDefault();
            let items = this.state.list;
            let {focusedItem} = this.state;
            let state = {}
            if(e.keyCode === 38) { // up
                state.focusedItem = focusedItem === 0 ? items.length - 1 : focusedItem - 1;
            } else if(e.keyCode === 40) { // down
                state.focusedItem = focusedItem === items.length - 1 ? 0 : focusedItem + 1;
            }
            if(state.focusedItem > -1 && state.focusedItem < items.length) {
                this.setState(state, () => {
                    let el = this.containerRef;
                    let items = Array.from(el.querySelectorAll('.imsc-item'));
                    items[this.state.focusedItem].scrollIntoViewIfNeeded();
                });
            }
        }
    }

    getStartIndex = ()=>{
        return this.state.index == 0? 1:(this.state.index*this.getMaxItemCount())+1
    }

    getLastIndex = ()=>{
    let dataList = this.props.data.listData
    return dataList.length>(this.state.index+1)*this.getMaxItemCount()?(this.state.index+1)*this.getMaxItemCount():dataList.length
    }

    getSelectedItems =()=>{
        let selected = this.props.data.selectedItems ? this.props.data.selectedItems : window.selectedItems ? window.selectedItems : window.selectedVehicles ?  window.selectedVehicles : []
        // console.log("selected",selected)
        return this.props.data.selectedItems ? this.props.data.selectedItems : window.selectedItems ? window.selectedItems : window.selectedVehicles ? window.selectedVehicles : [] 
    } 

    getSelectAllMessage =()=> {
        let itemindex = 0;
        let items = this.getSelectedItems();
        let item;
        if(items.length) {
            for(let jdx in items) {
                item = items[jdx];
                for(let idx= 0; idx < this.props.data.listData.length; idx++) {
                    if(this.props.data.listData[idx].id === item.id) {
                        if(idx > itemindex) {
                            itemindex=idx;
                        }
                    }
                }
            }
        } 
        itemindex++;
        this.highestItemIndex = itemindex;

        if(this.state.selectAllDisabled  != this.highestItemIndex >= (this.props.data.listData || []).length -1) {
            setTimeout(()=>{
                this.setState({selectAllDisabled: this.highestItemIndex >= (this.props.data.listData || []).length -1})
            })
        }

        return 'Select Next ' + Math.min(this.getMaxItemCount(), (this.props.data.listData||[]).length - itemindex);
    }

    throwMaxStackPopup =()=> {
        console.warn('You can\'t select more than');
        this.props.dispatch({
            type: actions.ADD_INTOAST,
            data:{
                name:'You can\'t select more than ' + this.getMaxItemCount() + ' items',
                content:'You can\'t select more than ' + this.getMaxItemCount() + ' items',
                createAt:Date.now(),
                autoClose: 7000
            }
        })
    }

    getMaxItemCount =()=> {
        if(this.props.store.reportWindow.tab.name == "Ride Report"){
            return this.props.data.maxCount || 10;
        }else{
        return this.props.data.maxCount || 100;
        }
    }

    isSelectAllDisabled =()=> {
        return this.state.selectAllDisabled
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.shortkeys);
        document.removeEventListener('click', this.hide);
        if(this.props.store.reportWindow.tab.key === 'can_data_dump_report') {
            window.selectedItems = []
        }
        if(this.props.store.reportWindow.tab.key === 'jem_can_data_dump_report'){
            window.selectedItems = []
        }
        if(this.props.store.reportWindow.tab.key === 'bg_can_data_dump_report'){
            window.selectedItems = []
        }
        // ideally this should work, but currently problematic
        // if('inmultiselect' in window.escapeListeners) delete window.escapeListeners['inmultiselect'];
        this.unmounted = true;
    }

    componentWillReceiveProps(props){
        if(props.data.reporttype !== this.props.data.reporttype){
            this.deSelectAll()
        }

        this.props = props;
        let reportKey = ["new_trip_report","trip_report","daily_report","summary_report","can_daily_report","range_report","download_report","mileage_report"]
        if(props.store.reportWindow.tab.key === 'hourly_report') {
            if(window.selectedHour && window.selectedHour.length) {
                this.props.data.selectedItems = window.selectedHour
                this.inputRef.current.value = window.selectedHour[0].name
                this.checkIsValid(window.selectedHour)
            }
        }
        if(reportKey.includes(props.store.reportWindow.tab.key) && window.selectAllClicked){
            this.setState({selectAllClicked: true})
        }
        if(props.store.reportWindow.tab.key != this.state.tab){
            // let reportKey = ["new_trip_report","trip_report","daily_report","summary_report","can_daily_report","range_report","download_report"]
            let key = props.store.reportWindow.tab.key 
            let singleSelect = this.props.data.singleSelect;
            if(!reportKey.includes(props.store.reportWindow.tab.key)) {
                window.selectAllClicked = false
                this.setState({selectAllClicked: false})
            }
            // window.selectedItems = []
            // window.selectedVehicles = []
            // if(window.selectedItems && window.selectedItems.length && window.vehicleMap && Object.keys(window.vehicleMap).length){
            //     if(reportKey.includes(props.store.reportWindow.tab.key) && window.selectedItems.length >=50 && window.selectedItems.length === Object.keys(window.vehicleMap).length){
            //         this.setState({selectAllClicked: true},() =>{})
            //     }else{
            //         this.setState({selectAllClicked:false})
            //     }
            // }
            if(window.selectedItems || window.selectedVehicles || window.selectedHour ){
                if(singleSelect){
                    window.selectAllClicked = false
                    // this.props.data.selectedItems = window.selectedVehicles
                    // this.checkIsValid(window.selectedVehicles);

                    if( window.selectedItems && window.selectedItems[0] || window.selectedVehicles && window.selectedVehicles[0] || window.selectedHour && window.selectedHour[0]){
                        if(this.isSingleSelect() && this.props.store.reportWindow.tab.key !== "hourly_report"){
                            if(this.props.data.key === "vehicle" && window.selectedVehicles.length) {
                                this.props.data.selectedItems = [window.selectedVehicles[0]]
                                this.inputRef.current.value = window.selectedVehicles[0].name
                                if(this.props.store.reportWindow.tab.key === "can_data_report") window.canDataVehicle =window.selectedVehicles[0].name
                                if(this.props.store.reportWindow.tab.key === "jem_can_data_report") window.canDataVehicle =window.selectedVehicles[0].name
                                if(this.props.store.reportWindow.tab.key === "bg_can_data_report") window.canDataVehicle =window.selectedVehicles[0].name
                                this.checkIsValid(window.selectedVehicles[0])
                                window.selectedVehicles = this.props.data.selectedItems
                            }
                            else if(this.props.data.key === 'matrics' && window.selectedItems.length){
                                this.props.data.selectedItems = window.selectedItems
                                this.inputRef.current.value = window.selectedItems[0].name
                                this.checkIsValid(window.selectedItems)
                            }
                            else if(this.props.data.key === 'hours' && window.selectedHour.length) {
                                this.props.data.selectedItems = window.selectedHour
                                this.inputRef.current.value = window.selectedHour[0].name
                                this.checkIsValid(window.selectedHour)
                            }
                            else {
                                this.props.data.selectedItems = []
                                this.inputRef.current.value = ''
                            }
                            // this.props.data.selectedItems = window.selectedItems
                            // this.refs.input.value = window.selectedItems[0].name
                            // this.checkIsValid(window.selectedItems);
                        } 
                    }
                }else {
                    this.inputRef.current.value = ''
                    if(this.props.store.reportWindow.tab.key === "tvs_report") {
                        this.props.data.selectedItems = window.selectedVehicles
                        this.props.data.selectedItems =  this.props.data.selectedItems.slice( this.state.index, this.getMaxItemCount())
                        window.selectedItems = window.selectedVehicles = this.props.data.selectedItems
                        // window.selectedItems = []
                        
                    }
                    else {
                        if(!(reportKey.includes(this.state.tab) && reportKey.includes(props.store.reportWindow.tab.key))){
                        window.selectedItems = props.data.selectedItems = window.selectedVehicles.slice( this.state.index, this.getMaxItemCount())
                    }
                    }
                }
            }
            if(window.selectedItems && window.selectedItems.length && window.vehicleMap && Object.keys(window.vehicleMap).length){
                if(reportKey.includes(props.store.reportWindow.tab.key) && window.selectedItems.length >=50 && window.selectedItems.length === Object.keys(window.vehicleMap).length){
                    this.setState({selectAllClicked: true},() =>{})
                }else{
                    this.setState({selectAllClicked:false})
                }
            }
            setTimeout(() => {
                this.checkIsValid(window.selectedVehicles);
            }, 100); 
            if( this.state.splitButton){this.setState({splitButton: false})}
            this.setState({tab:props.store.reportWindow.tab.key, index:0})
            // this.deSelectAll()
        }

        if(this.props.data){
            if(this.props.data.onStateChange){
                this.props.data.onStateChange(props.store, this);
            }
        }

        if(this.props.data && this.props.data.storeData){
            this.setData(this.props.data.storeData(this.props.store));
        }

        if(this.props.data.report != undefined){
        if(this.getSelectedItems().length) {
            // this.refs.input.value = this.getSelectedItems()[0].name;
        }
        }

        if(props.data.defaultValue) {
            let defVal = props.data.defaultValue(props.store);
            if(this.defaultValueUpdatedAt !== defVal.updatedAt) {
                this.defaultValueUpdatedAt = defVal.updatedAt;
                // this.setItemByIds(defVal.data);
            }
        }

    }

    componentDidMount(){
        // console.log("✅ InMultiSelect mounted with ref:", this);
        let reportKey = ["new_trip_report","trip_report","daily_report","summary_report","can_daily_report","range_report","mileage_report"]
        if(this.props.data && this.props.data.onload){
            this.props.data.onload(this);
        }

        if(this.props.data && this.props.data.storeData){
            this.setData(this.props.data.storeData(this.props.store));
        }
        // if(window.metrics){
        //     console.log("inside multiselect",window.metrics)
        //     this.forceUpdate()
        // } 
        // window.addEventListener('click', this.hide);
        if( window.selectedItems && window.selectedItems[0] || window.selectedVehicles && window.selectedVehicles[0]){
            // if(this.isSingleSelect() && this.props.store.reportWindow.tab.key !== "hourly_report"){
            if(this.props.store.reportWindow.tab.key !== "hourly_report"){
                if(this.props.data.key === "vehicle" && window.selectedVehicles.length) {
                    this.props.data.selectedItems = this.isSingleSelect() ? [window.selectedVehicles[0]] : !(reportKey.includes(this.state.tab)) ? window.selectedVehicles.slice( this.state.index, this.getMaxItemCount()) : window.selectedVehicles
                    this.inputRef.current.value = window.selectedVehicles[0].name
                    // window.canDataVehicle = ''
                    this.checkIsValid(window.selectedVehicles)
                }
                else if(this.props.data.key === 'matrics' && window.selectedItems.length){
                    this.props.data.selectedItems = window.selectedItems
                    this.inputRef.current.value = window.selectedItems[0].name
                    this.checkIsValid(window.selectedItems)
                }
                else if(this.props.data.key === 'hours' && window.selectedHour.length) {
                    this.props.data.selectedItems = window.selectedHour
                    this.inputRef.current.value = window.selectedHour[0].name
                    this.checkIsValid(window.selectedHour)
                }
                else if(this.props.store.reportWindow.tab.key === "tvs_report") {
                   
                    window.selectedVehicles.slice( this.state.index, this.getMaxItemCount())
                    this.props.data.selectedItems = window.selectedVehicles
                }
                else {
                    this.props.data.selectedItems = []
                    this.inputRef.current.value = ''
                }
                // this.props.data.selectedItems = window.selectedItems
                // this.inputRef.current.value = window.selectedItems[0].name
                // this.checkIsValid(window.selectedItems);
            } 
        }  
    }

    isItemNotInFilteredList =item=> !this.getListData().filter(i=>i.id === item.id)[0]

    openDwop = () => {
        let currentReport = ""
        let reportKey = ["new_trip_report","trip_report","daily_report","summary_report","can_daily_report","range_report","download_report","mileage_report"]
        this.inputRef.current.value = '';
        if(this.props.data.schemaKey !== undefined){
            currentReport = this.props.data.schemaKey

        }else {
            currentReport = this.props.data.getSchema().key
        }

        if(this.props.data.key === 'vehicle' && this.props.data.listData && !reportKey.includes(currentReport)){
            setTimeout(()=>{
                document.getElementById(this.props.data.listData[this.state.index*this.getMaxItemCount()].name).scrollIntoView()
            },500)
        }

        this.setState({focus: true, list: this.props.data.listData||[], focusedItem: this.focusedItem});
    }

    render(){
        let singleSelect = this.props.data.singleSelect;
        // let showSelectAll = this.props.data.key === 'vehicle' && _.get(this.props.data, 'listData', []).length < 101; as of now disabled 
        let showSelectAll = this.props.data.schemaKey ==="cnd_status_report" ? false : this.props.data.key === 'vehicle' ? true : this.props.data.key === 'metrics' ? true : false ;

        let {search} = this.state;
        return (
            <div className={Dom.Class({'active': this.state.focus}, "InMultiSelect")} ref={this.containerRef}>
                <input id="selectBox" className='inputSelectBox' autoComplete = "off" placeholder={this.getPlaceholder()} onClick={this.onFocus} ref={this.inputRef} onChange={this.onInputChange} />
                {/* {this.getSelectedItems().length > 1 && !singleSelect && search.length > 0 && !this.state.selectAllClicked && <span className="ims-pq">&amp; {this.getSelectedItems().length - 1} more</span>} */}
                {this.props.data.singleSelect ? (
                    <div className={"ims-validate" + (this.state.valid ? ' valid': '')}>
                        {this.state.valid ? <i className="fa fa-check"></i> : <i className="fa fa-ban"></i>}
                    </div>
                ) : ''}
                <button className="ims-dd" onClick={this.openDwop}><i className="fa fa-caret-down"></i></button>
                <div className="ims-container">
                    {/* <div><span>select all</span> <i className="fa fa-square-o"></i></div> */}
                    <div className="ims-container-scroll">
                        {/* <button className='imsc-item 1'><i className="fa fa-square-o"></i> SELECT ALL</button> */}
                        {this.props.data.listData && !this.state.selectAllClicked ? (
                            this.getListData().map((item, index)=> {
                                return (
                                    <button className={Dom.Class({'active': this.isActive(item, index)}, "imsc-item 1")} key={index} id={item.name} onMouseDown={()=>this.onItemClick(item, index)}>
                                        {!this.props.data || !this.props.data.singleSelect ? (
                                            this.isSelected(item) ? (
                                                <i className="fa fa-check-square -red"></i>
                                            ) : (
                                                // <i className="fa fa-square-o"></i>
                                                <input type="checkbox" className='imsc-checkbox'></input>
                                            )
                                        ):null}
                                        {item.name}
                                    </button>
                                )
                            })
                        ): showSelectAll && this.state.selectAllClicked   && 
                        <span className='imsc-item 1'>
                            Selected all {this.getSelectedItems().length} {this.props.data.key === 'metrics' ? "metrics" : "vehicles"}
                        </span>}
                        {this.props.data.listData && !singleSelect && !this.state.selectAllClicked && search.length  ? (
                            this.getSelectedItems().filter(this.isItemNotInFilteredList).map((item, index)=> {
                                return (
                                    <button className={Dom.Class({'active': this.isActive(item, index)}, "imsc-item 2")} key={index} onMouseDown={()=>this.onItemClick(item, index)}>
                                        {!this.props.data || !this.props.data.singleSelect ? (
                                            this.isSelected(item) ? (
                                                <i className="fa fa-check-square -red"></i>
                                            ) : (
                                                // <i className="fa fa-square-o"></i>
                                                <input type="checkbox" className='imsc-checkbox' style={{color: "#ccc", cursor:"pointer", width:13.3, height:15 }}></input>
                                            )
                                        ):null}
                                        {item.name}
                                    </button>
                                )
                            })
                        ):null}
                    </div>
                    {!this.props.data.singleSelect ? (
                        <div className="imsc-buttons">
                            {/* <div className={"imscb-button -green  " + (this.isSelectAllDisabled() ? ' -disabled' : '')} onClick={()=>this.selectAll()}>
                                <div className="imscbb-inner">{this.getSelectAllMessage()}</div>
                            </div> */}
                            {!this.state.splitButton && showSelectAll && <div className="imscb-button" >
                                <div className={Dom.Class({'disable': !(this.props.data.listData && this.props.data.listData.length)},"imscbb-inner")} onClick={()=>this.selectAll()}>Select All</div>
                            </div>}
                            {this.state.splitButton && <div className="splitButton">
                            <a className={Dom.Class({'disable': this.state.index == 0}, "prevbtn")} onClick={()=>this.prevList( this.state.index-1)} >Prev</a>
                            <a className={Dom.Class({'disable': this.state.index == Math.ceil(this.props.data.listData.length/this.getMaxItemCount())-1}, "nextbtn")} onClick={()=>this.nextList( this.state.index+1)} >Next</a>
                            </div>
                            }

                            <div className="imscb-button -red" >
                                <div className={Dom.Class({'disable': !(this.props.data.listData && this.props.data.listData.length)},"imscbb-inner")} onClick={()=>this.deSelectAll()}>Clear All</div>
                            </div>
                        </div>
                    ) : ''}
                </div>
                {this.props.data.busy ? (
                    <div className="ims-loader"></div>
                ):null}
            </div>
        )
    }

}
const InMultiSelect = React.forwardRef((props, ref) => {
    return <InMultiSelectClass {...props} ref={ref} />;
  });
// export default connect(MapPropsToState, null, null, { withRef: true })(InMultiSelect);
export default connect(MapPropsToState, null, null, { forwardRef: true })(InMultiSelect);
